import { Column, ColumnKeys, IntegrityMonitorRulesGridAllRulesGetRowsResponse, SetFiltersRequest } from '../types';
import { GridBaseDataProvider } from '../../../../grid/GridBaseDataProvider';
import {
  GetRowsRequest,
  GetSummaryRequest,
  GetSummaryResponse,
  UpdateSettingsRequest,
  UpdateSettingsResponse,
} from '../../../../grid/types/common';
import { sanitizeObject } from '../../../../utils/sanitization.utils';
import { DEFAULT_PAGE_SIZE } from '../../../../grid/gridView/types';

export class IntegrityMonitorRulesGridDataProvider extends GridBaseDataProvider<Column, ColumnKeys> {
  private response: any;

  constructor(public dependencies: any, private limit: number) {
    super();
  }

  async getSummary(request: GetSummaryRequest<ColumnKeys>): Promise<GetSummaryResponse> {
    request.pageSize = this.limit;
    request.extraParams['companyId'] = this.dependencies.getActiveCompany().companyId;

    const response = await this.dependencies.api.clients.IntegrityMonitorRules.readRecords(request).toPromise();

    this.response = response;

    return sanitizeObject({
      summary: this.dependencies.translateFn('{noOfItems} items', {
        noOfItems: response.total,
      }),
      numItems: response.total,
    });
  }

  async getRows(
    request: GetRowsRequest<Column, ColumnKeys>
  ): Promise<IntegrityMonitorRulesGridAllRulesGetRowsResponse> {
    let response = this.response;
    request.pageSize = this.limit;
    request.extraParams['companyId'] = this.dependencies.getActiveCompany().companyId;

    if (!response) {
      response = await this.dependencies.api.clients.IntegrityMonitorRules.readRecords(request).toPromise();
    } else {
      this.response = null;
    }

    return sanitizeObject({ rawEvents: response.data });
  }

  async setFilters(request: SetFiltersRequest): Promise<{} | undefined> {
    request.filters.forEach((filter, index) => {
      if (filter?.ruleName?.regex) {
        filter.ruleName.startsWith = filter.ruleName.regex.pattern;
        delete filter.ruleName.regex;
      }
    });

    return;
  }

  async updateSettings(request: UpdateSettingsRequest<Column>): Promise<UpdateSettingsResponse> {
    this.limit = request.pageSize ?? DEFAULT_PAGE_SIZE;
    return {};
  }

  shouldDataReloadOnResetView(): boolean {
    return true;
  }
}
